import { observer } from '@formily/reactive-vue'
import { h, useParentForm } from '@formily/vue'
import { defineComponent } from 'vue-demi'

import { Button as RichButton } from '@didi/rich-ui'

import './style.scss'

export const Submit = observer(
  defineComponent({
    name: 'FSubmit',
    props: ['onClick', 'onSubmit', 'onSubmitSuccess', 'onSubmitFailed'],
    setup (props, { attrs, slots, listeners }) {
      const formRef = useParentForm()

      return () => {
        const {
          onClick = listeners && listeners.click,
          onSubmit = listeners && listeners.submit,
          onSubmitSuccess = listeners && listeners.submitSuccess,
          onSubmitFailed = listeners && listeners.submitFailed
        } = props

        const form = formRef.value
        return h(
          RichButton,
          {
            attrs: {
              nativeType: listeners && listeners.submit ? 'button' : 'submit',
              type: 'primary',
              ...attrs,
              loading:
                attrs.loading !== undefined ? attrs.loading : form.submitting
            },
            on: {
              ...listeners,
              click: (e) => {
                if (onClick) {
                  if (onClick(e) === false) return
                }
                if (onSubmit) {
                  form.submit(onSubmit)
                    .then(onSubmitSuccess)
                    .catch(onSubmitFailed)
                }
              }
            }
          },
          slots
        )
      }
    }
  })
)

export default Submit
